/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const GenericModelType = {
    CalendarEvent: 'calendar-event',
    Chat: 'chat',
    ChatMessage: 'chat-message',
    CommunityTopic: 'communities-topic',
    KnowledgebasePage: 'knowledgebase-page',
    KnowledgebaseContent: 'knowledgebase-content',
    News: 'news',
    User: 'user'
} as const;
export type GenericModelType = typeof GenericModelType[keyof typeof GenericModelType];

